import { createFileRoute } from '@tanstack/react-router';

import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/$')({
  component: () => <NotFoundView />,
});
